const observed = new Set();

function supportsEntryType(type) {
  if (typeof PerformanceObserver === 'undefined') return false;
  const supported = PerformanceObserver.supportedEntryTypes;
  return Array.isArray(supported) && supported.includes(type);
}

function dispatchMetric(metricName, value) {
  window.dispatchEvent(new CustomEvent('starter:perf-metric', {
    detail: {
      metric: metricName,
      value: Math.round(value),
    },
  }));
}

function observeEntryType(type, metricName) {
  if (observed.has(type) || typeof PerformanceObserver === 'undefined') return;
  if (!supportsEntryType(type)) return;
  try {
    const observer = new PerformanceObserver((list) => {
      for (const entry of list.getEntries()) {
        dispatchMetric(metricName, entry.startTime);
      }
    });
    observer.observe({ type, buffered: true });
    observed.add(type);
  } catch {
    // Some browsers do not support all entry types.
  }
}

function observePaintEntry(name, metricName) {
  const key = `paint:${name}`;
  if (observed.has(key) || typeof PerformanceObserver === 'undefined') return;
  if (!supportsEntryType('paint')) return;

  try {
    const observer = new PerformanceObserver((list) => {
      for (const entry of list.getEntries()) {
        if (entry?.name === name) {
          dispatchMetric(metricName, entry.startTime);
        }
      }
    });
    observer.observe({ type: 'paint', buffered: true });
    observed.add(key);
  } catch {
    // Some browsers do not support all entry types.
  }
}

export function initPerfBaseline() {
  if (typeof window === 'undefined') return;
  observeEntryType('largest-contentful-paint', 'LCP');
  observePaintEntry('first-contentful-paint', 'FCP');
  observeEntryType('layout-shift', 'CLS');
  observeEntryType('event', 'INP');
}

